module.exports = __webpack_public_path__ + "img/logo-hamta.f57996e1.svg";